import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/layout";
import {
  Wallet,
  CreditCard,
  Plus,
  EyeOff,
  Eye,
 
  Check,
  X,
} from "lucide-react";
import paymentLogo from "../../assets/image/paymentlogo.png";

import cardlogo from "../../assets/image/CardLogos.png";
import { IoClose } from "react-icons/io5";
import { db } from "../../config/firebase";

import {

  doc,
 
  setDoc,
  getDoc,
 
} from "firebase/firestore";
import { useAppState } from "../../hooks/useAppState";
import { useWallet } from "../../hooks/useWallet";
import { addFunds, getWallet } from "../../services/walletService";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { RootState } from "../../store";
import { createNotification } from "../../store/slices/notificationSlice";


const Payment = () => {
  const { user } = useAppState();
  const dispatch = useAppDispatch(); // Update wallet states similar to navbar
  const { wallet,  } = useWallet();
  const orgData = useAppSelector(
    (state: RootState) => state.organization.currentOrganization
  );
  const [amount, setAmount] = useState(user?.amount || 0);
  const [balanceSuccess, setBalanceSuccess] = useState(false);
  // Add new state for tracking added amount
  const [addedAmount, setAddedAmount] = useState(0);
  // Add loading states
  const [isLoading, setIsLoading] = useState(true);
  const [cardsLoading, setCardsLoading] = useState(true);
  const [amountLoading, setAmountLoading] = useState(true);
  // Add debug logging for user state

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [cards, setCards] = useState([]);

  const [modalIsOpenAddAmount, setModalIsOpenAddAmount] = useState(false);

  const [inputAmount, setInputAmount] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  // Add states for delete confirmation
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [cardToDelete, setCardToDelete] = useState(null);

  const handleClose = () => {
    setBalanceSuccess(false);
  };
  const handleAddBalance = async (amount) => {
    if (!user?.uid || !amount || isNaN(Number(amount)) || Number(amount) <= 0) {
      return;
    }
    try {
      setIsProcessing(true);
      const numAmount = Number(amount);

      // Call the Firebase function to process the top-up
      try {
        const response = await fetch(
          `https://us-central1-supporty-staging.cloudfunctions.net/addTopup`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              userId: orgData?.wpCustomerId,
              amount: numAmount,
              currency: "USD",
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const responseData = await response.json();
        console.log("Parsed response data:", responseData);

        // Create notification for funds added
        if (user?.uid) {
          dispatch(
            createNotification({
              userId: user?.uid,
              userEmail: user?.email || "Unknown",
              message: `Amount $${numAmount.toFixed(
                2
              )} was added to your wallet`,
              trigger: "funds_added",
              triggeredBy: user?.uid || "unknown",
              meta: {
                amount: numAmount,
                walletId: wallet?.id || user.uid,
                addedAt: new Date().toISOString(),
                addedBy: user?.uid,
                adderName: user?.name || "User",
                previousBalance: wallet?.balance || 0,
                newBalance: (wallet?.balance || 0) + numAmount,
                paymentId: responseData.data?.paymentId,
                orderId: responseData.data?.orderId,
              },
            })
          );
        }
        if (responseData && responseData.success) {
          // Update local wallet service to reflect the changes
          await addFunds(
            wallet?.id || user.uid,
            numAmount,
            user.uid,
            "Wallet top-up via Stripe"
          );

          // Close all modals and reset input
          setModalIsOpenAddAmount(false);
          setModalIsOpenAmountDefault(false);
          setInputAmount("");

          // Show success popup
          setAddedAmount(numAmount);
          setBalanceSuccess(true);
        } else {
          throw new Error(responseData?.message || "Failed to process payment");
        }
      } catch (error) {
        console.error("Error calling addTopup function:", error);
        throw error; // Re-throw to be caught by outer catch block
      }
    } catch (error: any) {
      console.error("Error adding balance:", error);
      // Show error message to user
      alert(`Failed to add balance: ${error.message || "Unknown error"}`);
    } finally {
      setIsProcessing(false);
    }
  };

  const [modalIsOpenAmountDefault, setModalIsOpenAmountDefault] =
    useState(false);
  const [selectedAmount, setSelectedAmount] = useState(null);

  const openModal = (amountToAdd) => {
    setSelectedAmount(amountToAdd);
    setModalIsOpenAmountDefault(true);
  };

  const [selectedCardId, setSelectedCardId] = useState(1); // Default select the first card

  // Ensure at least one card is selected if available
  useEffect(() => {
    if (cards.length > 0 && !cards.some((card) => card.active)) {
      setActiveCard(cards[0].id);
    }
  }, [cards]);

  const setActiveCard = async (id) => {
    try {
      const userId = user?.uid || user?.id;
      if (!userId) return;

      const userRef = doc(db, "users", userId);
      const userDoc = await getDoc(userRef);
      const currentCards = userDoc.data()?.cards || [];

      // Update active status for all cards
      const updatedCards = currentCards.map((card) => ({
        ...card,
        active: card.id === id,
      }));

      // Save to Firebase
      await setDoc(userRef, { cards: updatedCards }, { merge: true });

      // Update local state
      setSelectedCardId(id);
      setCards(updatedCards);
    } catch (error) {
      console.error("Error updating active card:", error);
    }
  };

  const deleteCard = async (id) => {
    try {
      const userId = user?.uid || user?.id;
      if (!userId) return;

      const userRef = doc(db, "users", userId);
      const userDoc = await getDoc(userRef);
      const currentCards = userDoc.data()?.cards || [];

      // Filter out the card to delete
      const updatedCards = currentCards.filter((card) => card.id !== id);

      // Update user document
      await setDoc(userRef, { cards: updatedCards }, { merge: true });

      setCards(updatedCards);

      if (selectedCardId === id && updatedCards.length > 0) {
        setSelectedCardId(updatedCards[0].id);
      }

      // Close the confirmation modal
      setDeleteConfirmOpen(false);
      setCardToDelete(null);
    } catch (error) {
      console.error("Error deleting card:", error);
    }
  };

  // Handle opening delete confirmation
  const openDeleteConfirmation = (card) => {
    setCardToDelete(card);
    setDeleteConfirmOpen(true);
  };

  const [newCardData, setNewCardData] = useState({
    name: "",
    number: "",
    cvv: "",
    month: "",
    year: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [dateErrors, setDateErrors] = useState({ month: "", year: "" });
  // Add state for card form processing
  const [isCardProcessing, setIsCardProcessing] = useState(false);

  const formatCardNumber = (number) => {
    const digits = number.replace(/\D/g, "");
    const groups = digits.match(/.{1,4}/g);
    return groups ? groups.join(" ") : digits;
  };

  const validateDate = (name, value) => {
    const currentYear = new Date().getFullYear() % 100; // Get last 2 digits of current year
    const currentMonth = new Date().getMonth() + 1; // Get current month (1-12)

    if (name === "month") {
      // Check if month is between 1 and 12
      const month = parseInt(value);
      if (isNaN(month) || month < 1 || month > 12) {
        return "Invalid month (1-12)";
      }

      // Check if the expiration date is in the past
      if (
        newCardData.year &&
        parseInt(newCardData.year) === currentYear &&
        month < currentMonth
      ) {
        return "Card expired";
      }
    }

    if (name === "year") {
      // Check if year is current or future
      const year = parseInt(value);
      if (isNaN(year) || year < currentYear) {
        return "Must be current year or future";
      }

      // Check if the expiration date is in the past
      if (
        newCardData.month &&
        parseInt(newCardData.month) < currentMonth &&
        year === currentYear
      ) {
        setDateErrors((prev) => ({ ...prev, month: "Card expired" }));
      } else {
        setDateErrors((prev) => ({ ...prev, month: "" }));
      }
    }

    return "";
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "number") {
      // Remove any non-digit characters and format
      const digits = value.replace(/\D/g, "");
      const formatted = formatCardNumber(digits);
      setNewCardData((prev) => ({
        ...prev,
        [name]: formatted,
      }));
    } else if (name === "month" || name === "year") {
      // Allow only numbers for month and year
      const numbersOnly = value.replace(/\D/g, "");

      // Update the field value
      setNewCardData((prev) => ({
        ...prev,
        [name]: numbersOnly,
      }));

      // Validate date fields
      const error = validateDate(name, numbersOnly);
      setDateErrors((prev) => ({
        ...prev,
        [name]: error,
      }));
    } else {
      setNewCardData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!newCardData.number || newCardData.number.length !== 19) {
      errors.number = "Please enter a valid 16-digit card number";
    }
    if (!newCardData.name) {
      errors.name = "Card holder name is required";
    }

    // Enhanced expiry date validation
    if (!newCardData.month || !newCardData.year) {
      errors.expiry = "Please enter valid expiry date";
    } else {
      const month = parseInt(newCardData.month);
      const year = parseInt(newCardData.year);
      const currentYear = new Date().getFullYear() % 100;
      const currentMonth = new Date().getMonth() + 1;

      if (isNaN(month) || month < 1 || month > 12) {
        errors.expiry = "Month must be between 1-12";
      } else if (isNaN(year)) {
        errors.expiry = "Invalid year format";
      } else if (
        year < currentYear ||
        (year === currentYear && month < currentMonth)
      ) {
        errors.expiry = "Card has expired";
      }
    }

    if (!newCardData.cvv || newCardData.cvv.length !== 3) {
      errors.cvv = "Please enter valid CVV";
    }
    return errors;
  };

  // Add new state for visibility
  const [visibleCardId, setVisibleCardId] = useState(null);

  // Add CVV visibility state
  const [isCvvVisible, setIsCvvVisible] = useState(false);

  // Modify handleSaveCard to store only the actual number
  const handleSaveCard = async () => {
    const userId = user?.uid || user?.id;
    if (!userId) {
      console.error("Cannot save card - No user identifier found");
      return;
    }

    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    try {
      setIsCardProcessing(true); // Set processing to true when starting

      const cardData = {
        id: Date.now().toString(),
        name: newCardData.name,
        number: newCardData.number.replace(/\s/g, ""), // Remove spaces before storing
        cvv: newCardData.cvv,
        validUntil: `${newCardData.month}/${newCardData.year}`,
        active: false,
        createdAt: new Date().toISOString(),
      };

      const userRef = doc(db, "users", userId);
      const userDoc = await getDoc(userRef);
      const currentCards = userDoc.data()?.cards || [];

      await setDoc(
        userRef,
        {
          cards: [...currentCards, cardData],
        },
        { merge: true }
      );

      setCards([...cards, cardData]);
      setModalIsOpen(false);
      setNewCardData({
        name: "",
        number: "",
        cvv: "",
        month: "",
        year: "",
      });
      setFormErrors({});
    } catch (error) {
      console.error("Error saving card:", error);
    } finally {
      setIsCardProcessing(false); // Reset processing state when done
    }
  };

  // Add helper function to mask card number
  const maskCardNumber = (number) => {
    const lastFour = number.replace(/\s/g, "").slice(-4);
    return `**** **** **** ${lastFour}`;
  };

  // Add helper function to mask CVV
  const maskCVV = () => {
    return "***";
  };

  // Add toggle function for CVV visibility
  const toggleCvvVisibility = () => {
    setIsCvvVisible(!isCvvVisible);
  };

  useEffect(() => {
    const fetchCards = async () => {
      setCardsLoading(true);
      const userId = user?.uid || user?.id;
      if (!userId) {
        console.error("Cannot fetch cards - No user identifier found");
        setCardsLoading(false);
        return;
      }

      try {
        const userRef = doc(db, "users", userId);
        const userDoc = await getDoc(userRef);
        const userCards = userDoc.data()?.cards || [];
        setCards(userCards);
      } catch (error) {
        console.error("Error fetching cards:", error);
      } finally {
        setCardsLoading(false);
      }
    };

    fetchCards();
  }, [user]);
  // Update useEffect to fetch initial amount
  useEffect(() => {
    const fetchAmount = async () => {
      setAmountLoading(true);
      const userId = user?.uid || user?.id;
      if (!userId) return;

      try {
        const userDoc = await getDoc(doc(db, "users", userId));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setAmount(userData.amount || 0);
        }
      } catch (error) {
        console.error("Error fetching amount:", error);
      } finally {
        setAmountLoading(false);
      }
    };

    fetchAmount();
  }, [user]);

  // Add useEffect to fetch wallet similar to navbar
  useEffect(() => {
    if (!user?.uid) return;

    if (user.teamRole === "customer_owner") {
      getWallet(user?.orgId);
    } else if (
      user.teamRole === "customer_team_lead" ||
      user.teamRole === "customer_team_member" ||
      user?.role === "supporty_admin"
    ) {
      getWallet(user?.uid);
    }
  }, [user?.uid]);

  // Combined loading state
  useEffect(() => {
    setIsLoading(cardsLoading || amountLoading);
  }, [cardsLoading, amountLoading]);

  // Modified to handle edit mode properly
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingCard, setEditingCard] = useState(null);

  // Function to open modal for adding new card
  const openAddCardModal = () => {
    // Reset form state
    setNewCardData({
      name: "",
      number: "",
      cvv: "",
      month: "",
      year: "",
    });
    setFormErrors({});
    setIsEditMode(false);
    setEditingCard(null);
    setModalIsOpen(true);
  };

  // Function to open modal for editing card
  const handleEditCard = (card) => {
    setEditingCard(card);
    setNewCardData({
      name: card.name,
      number: formatCardNumber(card.number),
      cvv: card.cvv || "",
      month: card.validUntil.split("/")[0],
      year: card.validUntil.split("/")[1],
    });
    setIsEditMode(true);
    setModalIsOpen(true);
  };

  // Function to close modal and reset state
  const closeCardModal = () => {
    setModalIsOpen(false);
    setIsEditMode(false);
    setEditingCard(null);
    setNewCardData({
      name: "",
      number: "",
      cvv: "",
      month: "",
      year: "",
    });
    setFormErrors({});
  };

  const handleUpdateCard = async () => {
    const userId = user?.uid || user?.id;
    if (!userId) return;

    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    try {
      setIsCardProcessing(true); // Set processing to true when starting

      const userRef = doc(db, "users", userId);
      const userDoc = await getDoc(userRef);
      const currentCards = userDoc.data()?.cards || [];

      const updatedCards = currentCards.map((card) => {
        if (card.id === editingCard.id) {
          return {
            ...card,
            name: newCardData.name,
            number: newCardData.number.replace(/\s/g, ""), // Remove spaces before storing
            displayNumber: `**** **** **** ${newCardData.number.slice(-4)}`,
            cvv: newCardData.cvv,
            displayCvv: "***",
            validUntil: `${newCardData.month}/${newCardData.year}`,
            updatedAt: new Date().toISOString(),
          };
        }
        return card;
      });

      await setDoc(userRef, { cards: updatedCards }, { merge: true });
      setCards(updatedCards);
      closeCardModal();
    } catch (error) {
      console.error("Error updating card:", error);
    } finally {
      setIsCardProcessing(false); // Reset processing state when done
    }
  };

  // Add toggle visibility handler
  const toggleCardVisibility = (cardId) => {
    setVisibleCardId(visibleCardId === cardId ? null : cardId);
  };

  const [showAddConfirm, setShowAddConfirm] = useState(false);
  const [pendingAddAmount, setPendingAddAmount] = useState("");

  const [showAddLimitPopup, setShowAddLimitPopup] = useState(false);

  return (
    <Layout>
      <div
        className="p-6 bg-white rounded-lg shadow-sm w-full mx-auto"
        style={{
          height: "calc(100vh - 112px)",
        }}
      >
        {/* Payments Section */}
        <h2 className="text-[20px] text-[#696969] nunito-semibold">Payments</h2>

        <>
          {" "}
          {/* Wallet Section */}
          <div className=" flex h-auto py-5 px-5 shadow-lg rounded-[10px] justify-evenly items-center">
            <div className="flex-1">
              <h2 className="text-[18px] text-[#696969] nunito-semibold justify-start">
                Wallet
              </h2>

              <div className="p-4   flex flex-col items-center w-[313px]  ">
                <div className="flex bg-[#FEF0EA] rounded-lg w-[313px]  h-[120px] justify-around   items-center mb-5">
                  <Wallet className=" text-black w-[88px] h-[88px] mr-3 stroke-[0.5px]" />
                  <div>
                    {" "}
                    <p className="text-[16px] nunito-regular text-[#000000A6] mb-1">
                      Available Balance
                    </p>
                    <p className="text-[24px] nunito-bold  text-[#F15D18]">
                      ${wallet?.balance?.toFixed(2)}
                    </p>
                  </div>
                </div>

                <div className="relative group">
                  <button
                    className="bg-[#FCE2D5] text-[#F15D18] w-[313px] h-[49px] text-[16px] justify-center py-3 rounded-lg flex items-center nunito-medium transition"
                    onClick={() => setModalIsOpenAddAmount(true)}
                  >
                    <Plus className="w-[24px] h-[24px] mr-1" /> Add Balance $
                  </button>
                  <div className="absolute -top-7 -right-[100px] p-3  transform -translate-x-1/2 bg-white text-[12px] nunito-regular text-[#696969]  py-1 rounded-[10px] shadow opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap">
                    Click to add custom amount
                  </div>
                </div>

                <div className="flex space-x-3 w-[313px] h-[49px] mt-4">
                  {[5, 10, 20].map((amountToAdd) => (
                    <button
                      key={amountToAdd}
                      className="flex items-center bg-[#FBD3C0] text-[#F15D18]   h-[49px] text-[16px] px-3 py-2 rounded-[10px] nunito-medium shadow"
                      onClick={() => openModal(amountToAdd)}
                    >
                      <Plus className="w-[24px] h-[24px] " /> ${amountToAdd}
                      .00
                    </button>
                  ))}
                </div>
              </div>
              <span className=" nunito-regular text-[#919191]">
                To take expert sessions, you need to have sufficient balance in
                your wallet. This is where you can add balance, which can then
                be used to pay for any expert sessions you choose.
                <br />
                <br />
                Also, if you are a Team Owner, you will receive fund requests
                from your team members. To fulfill these requests:
                <ul className="list-disc list-inside">
                  <li>Add balance to your own wallet first</li>
                  <li>
                    Then, distribute funds to your team members’ wallets as
                    needed
                  </li>
                  <li>
                    Team members can use their wallet balance to book expert
                    sessions of their choice
                  </li>
                </ul>
              </span>
            </div>
            {/* balance success popup */}
            {balanceSuccess && (
              <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg w-[450px]  p-6 relative text-center shadow-lg">
                  {/* Close Button */}
                  <button
                    onClick={handleClose}
                    className="absolute top-3 right-3 text-[#696969] hover:text-gray-700"
                  >
                    <X className="w-[32px] h-[32px]" />
                  </button>

                  {/* Check Icon */}
                  <div className="flex justify-center mt-1">
                    <div className="bg-[#4BB847] border-gray-100 w-[126px] h-[126px] border-[10px] rounded-full p-4 flex items-center justify-center">
                      <Check className="text-white w-[80px] h-[80px]" />
                    </div>
                  </div>
                  <div className="">
                    {/* Amount */}
                    <p className="text-[32px] nunito-semibold text-[#F15D18] mt-4">
                      ${addedAmount}.00
                    </p>

                    {/* Success Message */}
                    <p className="text-[#404040] text-[32px] mt-1 nunito-semibold">
                      Successfully Added
                    </p>
                  </div>
                </div>
              </div>
            )}

            <div className="pr-[150px]">
              <img
                src={paymentLogo}
                alt="payment logo"
                className="w-[290px] h-[278px] "
              />
            </div>
          </div>
          {/* Card Information */}
          {/* <div className="p-6  rounded-lg shadow-lg  mt-10 ">
              <h2 className="text-[20px] text-[#919191] nunito-semibold mb-">
                Card information
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                {cards.map((card) => (
                  <div
                    key={card.id}
                    className={`relative rounded-lg p-5 cursor-pointer w-full`}
                    onClick={() => setActiveCard(card.id)}
                  >
                   
                    <div className="absolute top-4 right-8 flex space-x-2">
                      <button
                        className="text-[#919191]"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleCardVisibility(card.id);
                        }}
                      >
                        {visibleCardId === card.id ? (
                          <Eye className="w-[20px] h-[20px]" />
                        ) : (
                          <EyeOff className="w-[20px] h-[20px]" />
                        )}
                      </button>
                      <button
                        className="text-[#919191]"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditCard(card);
                        }}
                      >
                        <PencilIcon className="w-[20px] h-[20px]" />
                      </button>
                      <button
                        className="text-[#919191]"
                        onClick={(e) => {
                          e.stopPropagation();
                          openDeleteConfirmation(card);
                        }}
                      >
                        <TrashIcon className="w-[20px] h-[20px]" />
                      </button>
                    </div>

                    <div>
                      <div className="relative group">
                        <button
                          className={`flex absolute -left-6 w-[24px] h-[24px] rounded-full ${
                            card.active
                              ? "border-[#F15D18] border-[7px]"
                              : "text-[#C4C4C4] border-[7px]"
                          }`}
                        />
                        <div className="absolute  -top-8 bg-white p-2 rounded-[8px] shadow-md text-[12px] nunito-regular  text-[#696969] opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap">
                          {card.active
                            ? "Default card"
                            : "Click to set as default"}
                        </div>
                      </div>
                      <div className="mt-6 ml-2 grid grid-cols-2 gap-y-4 bg-[#FEF0EA] h-[142px] max-w-[360px]  rounded-[16px] p-4 mx-auto">
                        <div>
                          <p className="text-[12px] text-[#2b2b2b] nunito-medium">
                            Card name
                          </p>
                          <p className="text-[14px] text-[#919191]  nunito-bold">
                            {card.name}
                          </p>
                        </div>
                        <div>
                          <p className="text-[12px] nunito-medium text-[#2b2b2b]">
                            Card number
                          </p>
                          <p className="text-[14px] text-[#919191] nunito-bold">
                            {visibleCardId === card.id
                              ? formatCardNumber(card.number)
                              : maskCardNumber(card.number)}
                          </p>
                        </div>
                        <div>
                          <p className="text-[12px] text-[#2b2b2b] nunito-medium">
                            CVV
                          </p>
                          <p className="text-[14px] text-[#919191] nunito-bold">
                            {visibleCardId === card.id ? card.cvv : maskCVV()}
                          </p>
                        </div>
                        <div>
                          <p className="text-[12px] nunito-medium text-[#2b2b2b]">
                            Valid until
                          </p>
                          <p className="text-[14px] nunito-bold  text-[#919191]">
                            {card.validUntil}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                <div className="items-center flex w-full">
                  <button
                    className="flex items-center justify-center gap-1 w-full max-w-[290px] h-[49px] rounded-[10px] bg-[#FCE2D5]  hover:bg-orange-100 transition-colors mx-auto"
                    onClick={openAddCardModal}
                  >
                    <PlusIcon className="w-[24px] h-[24px] text-[#F15D18]" />
                    <span className="text-[#F15D18] text-[16px] nunito-medium ">
                      Create new card
                    </span>
                  </button>
                </div>
              </div>
            </div> */}
          {/*  */}{" "}
        </>

        {/* Add card model */}
        {modalIsOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div
              className="fixed inset-0 bg-black bg-opacity-50"
              onClick={closeCardModal}
            ></div>
            <div className="bg-white rounded-lg shadow-lg p-6 w-[594px]  z-10">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-[24px] text-[#0A0A0A] nunito-semibold">
                  {isEditMode ? `Edit Card ` : "Add Card"}
                </h2>
                <button onClick={closeCardModal} className="text-[#696969] ">
                  <IoClose className="w-[32px] h-[32px]" />
                </button>
              </div>
              <div className="bg-[#FCE2D5] p-4 rounded-[16px]">
                <div className="flex justify-between mb-4">
                  <h2 className="flex items-center gap-2 nunito-regular text-[16px] text-[#0A0A0A">
                    <CreditCard className="w-[24px] h-[24px] stroke-[2px]" />{" "}
                    Credit/Debit Card
                  </h2>
                  <img
                    src={cardlogo}
                    alt="Visa"
                    className="w-[96px] h-[28px] justify-end"
                  />
                </div>

                <div className="flex h-[48px] items-center mt-4">
                  <label className="block w-[257px] mt-4 ">
                    <h2 className="text-[#0A0A0A] text-[16px] nunito-regular">
                      Card Number
                    </h2>
                    <p className=" text-[12px] nunito-regular text-[#696969]">
                      Enter the 16-digit card number
                    </p>
                    {formErrors.number && (
                      <p className="text-red-500 text-xs">
                        {formErrors.number}
                      </p>
                    )}
                  </label>
                  <div>
                    <input
                      type="text"
                      name="number"
                      value={newCardData.number}
                      onChange={handleInputChange}
                      maxLength={19}
                      className="w-[257px] h-[48px] p-2 border rounded-[8px] mt-1"
                    />
                  </div>
                </div>
                <div className="flex mt-4">
                  <label className="block w-[257px] mt-4 ">
                    <p className="text-[#0A0A0A] text-[16px] nunito-regular">
                      Card Holder Name
                    </p>
                    <p className=" text-[12px] nunito-regular text-[#696969]">
                      Enter the name mentioned on your card
                    </p>
                    {formErrors.name && (
                      <p className="text-red-500 text-xs">{formErrors.name}</p>
                    )}
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={newCardData.name}
                    onChange={handleInputChange}
                    className="w-[257px] h-[48px] p-2 border rounded-[8px] mt-1"
                  />
                </div>
                <div className="">
                  <div className="flex items-center justify-between mt-4">
                    <label className="block w-[264px] items-center">
                      <p className="text-[#0A0A0A] text-[16px] nunito-regular">
                        Expiration Date
                      </p>
                      <p className=" text-[12px] nunito-regular text-[#696969]">
                        Enter the expiration date mentioned on your card
                      </p>
                      {formErrors.expiry && (
                        <p className="text-red-500 text-xs">
                          {formErrors.expiry}
                        </p>
                      )}
                      {/* Combined date errors display */}
                      {(dateErrors.month || dateErrors.year) && (
                        <p className="text-red-500 text-[11px]">
                          {dateErrors.month || dateErrors.year}
                        </p>
                      )}
                    </label>
                    <div className="flex gap-2 w-[140px] justify-end">
                      <div className="relative">
                        <input
                          type="text"
                          name="month"
                          placeholder="MM"
                          value={newCardData.month}
                          onChange={handleInputChange}
                          maxLength={2}
                          className={`w-[56px] h-[48px] p-2 border-[#D9D9D9] border-[1px] rounded-[8px] text-center ${
                            dateErrors.month ? "border-red-500" : ""
                          }`}
                        />
                      </div>
                      <span className="self-center">/</span>
                      <div className="relative">
                        <input
                          type="text"
                          name="year"
                          placeholder="YY"
                          value={newCardData.year}
                          onChange={handleInputChange}
                          maxLength={2}
                          className={`w-[56px] h-[48px] p-2 border-[#D9D9D9] border-[1px] rounded-[8px] text-center ${
                            dateErrors.year ? "border-red-500" : ""
                          }`}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center justify-between mt-4">
                    <label className="block w-[257px] text-sm">
                      <p className="text-[#0A0A0A] text-[16px] nunito-regular">
                        CVV
                      </p>
                      <p className=" text-[12px] nunito-regular text-[#696969]">
                        Enter the security code
                      </p>
                      {formErrors.cvv && (
                        <p className="text-red-500 text-xs">{formErrors.cvv}</p>
                      )}
                    </label>
                    <div className="relative flex items-center">
                      <button
                        type="button"
                        onClick={toggleCvvVisibility}
                        className="mr-2 text-[#919191] hover:text-gray-700"
                      >
                        {isCvvVisible ? (
                          <Eye className="w-[24px] h-[24px]" />
                        ) : (
                          <EyeOff className="w-[24px] h-[24px]" />
                        )}
                      </button>
                      <input
                        type={isCvvVisible ? "text" : "password"}
                        name="cvv"
                        placeholder="***"
                        value={newCardData.cvv}
                        onChange={handleInputChange}
                        maxLength={3}
                        className="w-[86px] h-[48px] px-2 border rounded-[8px] text-[#404040] text-[16px] text-center"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="justify-center flex">
                <button
                  onClick={isEditMode ? handleUpdateCard : handleSaveCard}
                  className="w-[120px] h-[40px] mt-4 bg-[#F15D18] text-[16px] nunito-semibold text-white py-2 rounded-[8px] disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  {isCardProcessing ? "Processing..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Add amount model */}
        {modalIsOpenAddAmount && (
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div
              className="fixed inset-0 bg-black bg-opacity-30"
              onClick={() => setModalIsOpenAddAmount(false)}
            ></div>
            <div className="bg-white rounded-[24px]  p-6 w-[468px] h-[257px] z-10">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-[24px] nunito-semibold text-[#0A0A0A]">
                  Add Balance
                </h2>
                <button
                  onClick={() => setModalIsOpenAddAmount(false)}
                  className="text-[#696969]  "
                >
                  <IoClose className="w-[32px] h-[32px]" />
                </button>
              </div>
              <div className="border-[#EBEBEB] border-[1px] p-4 rounded-[16px]">
                <label className="block text-[16px] nunito-semibold text-[#404040]">
                  Amount
                </label>
                <input
                  type="number"
                  placeholder="Enter Amount"
                  value={inputAmount}
                  onChange={(e) => setInputAmount(e.target.value)}
                  className="w-full p-2 text-[14px] nunito-normal border border-[#404040] rounded-[6px] text-[#404040] mt-1"
                />
              </div>
              <div className="justify-center flex">
                <button
                  onClick={() => {
                    if (
                      !inputAmount ||
                      isNaN(Number(inputAmount)) ||
                      Number(inputAmount) <= 0
                    ) {
                      return;
                    }
                    if (Number(inputAmount) > 5000) {
                      setPendingAddAmount(inputAmount);
                      setModalIsOpenAddAmount(false);
                      setShowAddLimitPopup(true);
                    } else if (Number(inputAmount) > 999) {
                      setPendingAddAmount(inputAmount);
                      setShowAddConfirm(true);
                    } else {
                      handleAddBalance(inputAmount);
                    }
                  }}
                  disabled={
                    isProcessing ||
                    !inputAmount ||
                    isNaN(Number(inputAmount)) ||
                    Number(inputAmount) <= 0
                  }
                  className="w-[120px] h-[40px] mt-4 bg-[#F15D18] text-white text-[16px] nunito-bold py-2 rounded-[8px] disabled:bg-opacity-70 disabled:cursor-not-allowed"
                >
                  {isProcessing ? "Processing..." : "Add Now"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Show confirmation popup if showAddConfirm is true */}
        {showAddConfirm && (
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6  w-[500px] h-[260px]  text-center relative">
              <button
                onClick={() => {
                  setShowAddConfirm(false);
                  setPendingAddAmount("");
                }}
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
              >
                <X size={24} />
              </button>
              <div className="mb-6 mt-8 text-[20px] text-gray-800 nunito-semibold">
                You're about to add ₹{pendingAddAmount} to your wallet. Ready to add this amount?
              </div>
              <div className="flex justify-center  gap-4 mt-4">
                <button
                  className="py-2 w-[120px] h-[40px] bg-[#F15D18] items-center text-[16px] text-[#FFFFFF] nunito-semibold rounded-[8px] hover:bg-orange-600"
                  onClick={async () => {
                    setShowAddConfirm(false);
                    await handleAddBalance(pendingAddAmount);
                    setPendingAddAmount("");
                  }}
                  disabled={isProcessing}
                >
                  Yes
                </button>
                <button
                  className="py-2 border w-[120px] h-[40px] items-center border-[#F15D18] text-[#F15D18] nunito-semibold rounded-[8px] "
                  onClick={() => {
                    setShowAddConfirm(false);
                    setPendingAddAmount("");
                  }}
                  disabled={isProcessing}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Add Balance Limit Modal (>5000) */}
        {showAddLimitPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[500px] text-center relative">
              <div className="mb-6 mt-8 text-[20px] text-gray-800 nunito-semibold">
                Oops! You can only add up to ₹5,000 at a time.
              </div>
              <div className="flex justify-center gap-4 mt-4">
                <button
                  className="py-2 w-[160px] h-[40px] bg-[#F15D18] items-center text-[16px] text-[#FFFFFF] nunito-semibold rounded-[8px] hover:bg-orange-600"
                  onClick={() => {
                    setShowAddLimitPopup(false);
                    setModalIsOpenAddAmount(true);
                    setInputAmount(pendingAddAmount);
                  }}
                >
                  Change Amount
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Add Balance Default Amount Popup */}
        {modalIsOpenAmountDefault && (
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div
              className="fixed inset-0 bg-black bg-opacity-50"
              onClick={() => setModalIsOpenAmountDefault(false)}
            ></div>
            <div className="bg-white rounded-[24px] shadow-lg p-6 w-[468px] h-[197px] justify-center text-center z-10">
              <div className="flex justify-between items-center mb-4">
                <h2 className=" nunito-semibold text-[#0A0A0A] text-[24px]">
                  Add Balance
                </h2>
                <button
                  onClick={() => setModalIsOpenAmountDefault(false)}
                  className="text-[#696969]"
                >
                  <IoClose className="w-[32px] h-[32px]" />
                </button>
              </div>
              <p className="nunito-semibold text-[#F15D18] text-[32px]">
                Add ${selectedAmount}.00
              </p>
              <button
                onClick={() => handleAddBalance(selectedAmount)}
                disabled={isProcessing}
                className="mt-4 w-[120px] bg-[#F15D18] text-white text-[16px] nunito-semibold py-2 px-6 rounded-[8px] disabled:bg-opacity-70 disabled:cursor-not-allowed"
              >
                {isProcessing ? "Processing..." : "Confirm"}
              </button>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {deleteConfirmOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div
              className="fixed inset-0 bg-black bg-opacity-50"
              onClick={() => setDeleteConfirmOpen(false)}
            ></div>
            <div className="bg-white w-[549px] rounded-lg shadow-[16px]  p-6 z-10">
              <div className="flex justify-between items-center">
                <p className="text-[24px] nunito-semibold text-[#0A0A0A]">
                  Are you sure you want to delete card?
                </p>
                <button
                  className="text-gray-500 hover:text-gray-700"
                  onClick={() => setDeleteConfirmOpen(false)}
                >
                  <X className="w-[32px] h-[32px]" />
                </button>
              </div>
              <div className="flex justify-center mt-7 space-x-4">
                <button
                  className="py-3 border w-[120px] h-[40px] items-center border-[#F15D18] text-[#F15D18] nunito-semibold rounded-[8px] "
                  onClick={() => setDeleteConfirmOpen(false)}
                >
                  No
                </button>
                <button
                  className="py-3 w-[120px] h-[40px] bg-[#F15D18] items-center text-[16px] text-[#FFFFFF] nunito-semibold rounded-[8px] hover:bg-orange-600"
                  onClick={() => deleteCard(cardToDelete.id)}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Payment;
